// fonts.ts
import { Color, Font, FontUnit, TextAlign } from 'excalibur';

export const VietnamPro = new Font({
    family: 'Be Vietnam Pro',
    size: 72,
    unit: FontUnit.Px,
    textAlign: TextAlign.Center,
    color: Color.White
});
